import { Button, Group, Modal, Text } from '@mantine/core';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export default function UserCreatedModal({ opened, onClose }: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title="User created" centered>
      <Text>User was successfully created.</Text>
      <Group justify="flex-end" mt="md">
        <Button onClick={onClose}>OK</Button>
      </Group>
    </Modal>
  );
}
